var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcFog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.78,1.17A36.13,36.13,0,1,0,73.9,37.3,36.17,36.17,0,0,0,37.78,1.17Zm0,70.25A34.13,34.13,0,1,1,71.9,37.3,34.17,34.17,0,0,1,37.78,71.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.22,33.88a8,8,0,0,0-10.47-7.63,10.23,10.23,0,0,0-20.4,1,10.85,10.85,0,0,0,.2,2h-1.9a6.32,6.32,0,0,0,0,12.63H49.91a6.3,6.3,0,0,0,4.67-2.08A8,8,0,0,0,57.22,33.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.88,46.34H23.25a1.13,1.13,0,1,1,0-2.25H50.88a1.13,1.13,0,0,1,0,2.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.88,50.39H23.25a1.13,1.13,0,1,1,0-2.25H50.88a1.13,1.13,0,0,1,0,2.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.88,54.44H23.25a1.13,1.13,0,0,1,0-2.26H50.88a1.13,1.13,0,0,1,0,2.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcFog);
export default __webpack_public_path__ + "static/media/dc_fog.c8aea4f6fe2394229248a5342b8aa27b.svg";
export { ForwardRef as ReactComponent };